import type { IProps, ModalFooterActionsRemoveFactory } from "./modal-footer-actions-remove.types";
import styles from "../../../modal.module.scss";
import { polymorphicComponentWrapper } from "../../../../../utilities";
import { Button } from "../../../../button";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";

const ModalFooterActionsRemove = polymorphicComponentWrapper<ModalFooterActionsRemoveFactory, IProps>(
    "ModalFooterActionsRemove",
    ({ text, icon, ...otherProps }, ref) => {
        return (
            <Button
                color="red"
                ref={ref}
                icon={icon === null ? undefined : (icon ?? faTrash)}
                className={styles["footer-actions-remove"]}
                data-testid="remove-button"
                {...otherProps}
            >
                {text || "Remove"}
            </Button>
        );
    }
);

export { ModalFooterActionsRemove };
